module.exports = __webpack_public_path__ + "img/arrow_up.f5c08fc2.svg";